"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCatalogueFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M24 4c-3.11 0-5.51.71-7 2.08V24h-2V6.08C13.51 4.72 11.11 4 8 4H2v21h8c2.06 0 3.59.47 4.3 1.33a3.16 3.16 0 01.7 2.39V29h2v-.27a3.17 3.17 0 01.71-2.4C18.42 25.47 20 25 22 25h8V4z" })));
}
exports.default = SvgCatalogueFilled;
//# sourceMappingURL=CatalogueFilled.js.map